import css from './index.module.scss';
import { LineSpace } from '@/components/ProductComponents';
import { ImgCellsWithText, TextOnImage, TextWithImage } from '@/components/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import OtherList from '@/components/ProductCommon/OtherList';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_river_river_256'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_2'],
    mx: ['product_ps_river_703', 'product_ps_river_river_768', 'product_ps_river_river_512'],
    ph: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
};

export default function Content() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('110wsolarpanel');
    const languageT = (value: string) => t(`solarpanels_110w.${value}`);

    const webpUrl = '/media/solarpanel_110w/pc/';

    const item1 = {
        synopsis: languageT('third_title'),
        desc: languageT('third_des'),
        bgImgs: ['3_screen.webp', '3_screen.jpg'],
    };
    const textData3 = {
        synopsis: languageT('four_title'),
        desc: languageT('four_des'),
        bgImgs: ['3.webp', '3.jpg'],
    };
    const textData4 = {
        synopsis: languageT('five_title'),
        desc: languageT('five_des'),
        bgImgs: ['4.webp', '4.jpg'],
    };
    const textData1 = {
        img_url: ['4_camera.webp', '4_camera.jpg'],
        synopsis: languageT('six_title'),
        desc: languageT('six_des'),
        tip: languageT('six_tip'),
    };

    const textData2 = {
        img_url: ['7_solar.webp', '7_solar.jpg'],
        synopsis: languageT('seven_title'),
        desc: languageT('seven_des'),
    };
    const imgCellData = {
        guide: languageT('eight_title'),
        title: languageT('eight_subtitle'),
        desc1: languageT('eight_des'),
        desc2: languageT('eight_des1'),
        items: [
            {
                url: ['5_solar-panel.webp', '5_solar-panel.jpg'],
                guide: languageT('eight_item_title'),
                titleLeft: languageT('eight_item_hours'),
                desc: languageT('eight_item_des'),
            },
            {
                url: ['5_solar-panel1.webp', '5_solar-panel1.jpg'],
                guide: languageT('eight_item1_title'),
                titleLeft: languageT('eight_item1_hours'),
                desc: languageT('eight_item1_des'),
            },
            {
                url: ['5_solar-panel2.webp', '5_solar-panel2.jpg'],
                guide: languageT('eight_item2_title'),
                titleLeft: languageT('eight_item2_hours'),
                desc: languageT('eight_item2_des'),
            },
            {
                url: ['5_solar-panel3.webp', '5_solar-panel3.jpg'],
                guide: languageT('eight_item3_title'),
                titleLeft: languageT('eight_item3_hours'),
                desc: languageT('eight_item3_des'),
            },
        ],
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <LineSpace height={180} background="transparent" />
            <div className="banner-content">
                <div className="section section1">
                    <div className="section sec1-top">
                        <h3 className="tit">{languageT('second_powerfully')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_110w/pc/sec1-top.webp')}
                                src={require('@publicLocal/product/solarpanel_110w/pc/sec1-top.jpg')}
                                className="fullImgs"
                                alt={languageT('second_powerfully')}
                            />
                        </div>
                    </div>
                    <div className="section sec1-btm">
                        <h3
                            className="tit"
                            dangerouslySetInnerHTML={{
                                __html: languageT('second_hight_conversion_rate'),
                            }}
                        ></h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_110w/pc/sec1-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_110w/pc/sec1-btm.jpg')}
                                className="fullImgs"
                                alt={languageT('second_hight_conversion_rate')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-top">
                        <div className="section sec2-top-l">
                            <h3 className="tit">{languageT('second_adjustable')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_110w/pc/sec2-top-l.webp')}
                                    src={require('@publicLocal/product/solarpanel_110w/pc/sec2-top-l.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_adjustable')}
                                />
                            </div>
                        </div>
                        <div className="section sec2-top-r">
                            <h3 className="tit">{languageT('second_easy_to_plug')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_110w/pc/sec2-top-r.webp')}
                                    src={require('@publicLocal/product/solarpanel_110w/pc/sec2-top-r.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_easy_to_plug')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <h3 className="tit">
                            {languageT('second_ip')}
                            <span> {languageT('second_waterproof')}</span>
                        </h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_110w/pc/sec2-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_110w/pc/sec2-btm.jpg')}
                                className="fullImgs"
                                alt={languageT('second_waterproof')}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <LineSpace height={180} background="transparent" />
            <TextOnImage data={item1} config={{ position: 'top', descFontSize: locale === 'jp' ? '20' : '22', webpUrl }} />

            <LineSpace height={220} background="transparent" />
            <div className="container">
                <TextOnImage
                    data={textData3}
                    config={{
                        position: locale == 'sa' ? 'right' : 'left',
                        descFontSize: locale === 'jp' ? '20' : '22',
                        width: locale === 'cn' ? '490px' : '550px',
                        webpUrl,
                        synopsisFontSize: locale === 'br' ? '48' : '64',
                    }}
                />
            </div>

            <LineSpace height={140} background="transparent" />
            <div className="container textImgBox2">
                <TextOnImage
                    data={textData4}
                    config={{
                        position: locale == 'sa' ? 'left' : 'right',
                        descFontSize: locale === 'jp' ? '20' : '22',
                        width: locale === 'cn' ? '490px' : '550px',
                        webpUrl,
                        synopsisFontSize: locale === 'br' ? '48' : '64',
                    }}
                />
            </div>

            <LineSpace height={220} background="transparent" />
            <TextWithImage data={textData1} config={{ position: 'top', descFontSize: locale === 'jp' ? '20' : '22', webpUrl }} />

            <LineSpace height={300} background="transparent" />
            <div className="textImgBox4">
                <TextWithImage data={textData2} config={{ position: 'top', descFontSize: locale === 'jp' ? '20' : '22', webpUrl }} />
            </div>

            <LineSpace height={300} background="transparent" />
            <div className="products">
                <ImgCellsWithText data={imgCellData} descFamily={'Manrope-SemiBold'} webpUrl={webpUrl} />
                {locale === 'cn' && <p className="memo">{languageT('memo')}</p>}
            </div>

            <LineSpace height={280} background="transparent" />
            {/* {locale !== 'br' && */}
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
            {/* } */}
        </div>
    );
}
